// extracted by mini-css-extract-plugin
export default {"reactionsWrapper":"styles_reactionsWrapper__jYKQm"};